// Estimated from where the homes are, in the order they are walked. A route follows streets rather
// than a straight line, so each leg is the straight-line distance stretched by the usual allowance
// for a street grid.
const STREET_FACTOR = 1.3;
// 3 mph, an unhurried walk with a group.
const MINUTES_PER_MILE = 20;
const MINUTES_AT_EACH_HOME = 12;
// More than an hour's walk between two homes in a row is not a walking tour, so the estimate says so
// rather than giving a time.
const WALKABLE_LEG_MILES = 3;
const EARTH_RADIUS_MILES = 3958.8;
// Past this, the Homes summary suggests the tour is getting long for one outing.
export const LONG_TOUR_HOMES = 8;
const radians = (degrees) => degrees * Math.PI / 180;
// Great-circle distance by the haversine formula.
const milesBetween = (a, b) => {
    const h = Math.pow(Math.sin(radians(b.lat - a.lat) / 2), 2)
        + Math.cos(radians(a.lat)) * Math.cos(radians(b.lat)) * Math.pow(Math.sin(radians(b.lng - a.lng) / 2), 2);
    return 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(h));
};
const legMiles = (from, to) => from.lat === null || from.lng === null || to.lat === null || to.lng === null
    ? 0
    : milesBetween({ lat: from.lat, lng: from.lng }, { lat: to.lat, lng: to.lng }) * STREET_FACTOR;
export const estimateTour = (homes) => {
    const legs = homes.slice(1).map((home, i) => legMiles(homes[i], home));
    const miles = legs.reduce((total, leg) => total + leg, 0);
    const walkingMinutes = Math.round(miles * MINUTES_PER_MILE);
    const longest = legs.reduce((most, leg, i) => leg > most.miles ? { from: i + 1, to: i + 2, miles: leg } : most, { from: 0, to: 0, miles: 0 });
    return {
        miles,
        walkingMinutes,
        durationMinutes: walkingMinutes + homes.length * MINUTES_AT_EACH_HOME,
        tooFar: longest.miles > WALKABLE_LEG_MILES ? longest : null,
    };
};
export const formatMiles = (miles) => `${miles < 10 ? miles.toFixed(1) : Math.round(miles).toLocaleString('en-US')} mi`;
export const formatMinutes = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return hours === 0 ? `${rest} min` : rest === 0 ? `${hours} hr` : `${hours} hr ${rest} min`;
};
